import { NavController, NavParams, ModalController } from 'ionic-angular';
import { Component } from '@angular/core';
import { Storage } from '@ionic/storage';

// import { PincodeModal } from '../../app/pincode';
import { EmployeeData } from "../../providers/employee-data";
import { LoginPage } from '../login/login';

@Component({
    templateUrl: 'settings.html',
    selector: 'page-settings'
})
export class SettingsPage {
    userSettings;
    confirmExitApp = true;
    usePincode;
    pincode: string = null;
    pincode2: string = null;
    pincodeMask: string;
    pincode2Mask: string;
    password: string = null;
    password2: string = null;

    constructor(private nav: NavController, private navParams: NavParams, private storage: Storage, private modal: ModalController, private employeeData: EmployeeData) {
        this.userSettings = {};
        // this.userData.getUserSettings().then((userSettings) => {
        //      this.userSettings = userSettings;
        // });
    }

    // updateNotificationSetting(userSettings) {
    //     if(!userSettings.notificationsEnabled){
    //         this.parentData.saveRegistrationId(this.parentData.parent_id, null);
    //     }
    //     this.userData.setUserSettings(this.userSettings);
    // }

    // updatePincodeSetting() {
    //     this.parentData.savePincode(this.pincode).then(success => {
    //         if (success) {
    //             this.pincode = null;
    //             this.pincode2 = null;
    //             this.pincodeMask = "";
    //             this.pincode2Mask = "";
    //             this.userData.setUserSettings(this.userSettings);
    //         }
    //     });
    // }

    // togglePincode() {
    //     if (!this.userSettings.usePincode) {
    //         this.pincode = null;
    //         this.pincode2 = null;
    //         this.parentData.savePincode(this.pincode).then(success => {
    //             if (success) {
    //                 this.userData.setUserSettings(this.userSettings);
    //             }
    //         });
    //     } else {

    //     }
    // }

    // setPincode() {
    //     let pincodeModal = this.modal.create(PincodeModal, { setPincode: true }, );
    //     pincodeModal.present();
    //     pincodeModal.onDidDismiss(pincode => {
    //         if (pincode) {
    //             this.pincode = pincode;
    //             this.pincodeMask = "●●●●●";
    //         }
    //     });
    // }

    // setPincode2() {
    //     let pincodeModal = this.modal.create(PincodeModal, { setPincode: true }, );
    //     pincodeModal.present();
    //     pincodeModal.onDidDismiss(pincode => {
    //         if (pincode) {
    //             this.pincode2 = pincode;
    //             this.pincode2Mask = "●●●●●";
    //         }
    //     });
    // }

    updatePasswordSetting() {
        this.employeeData.setEmployeePassword(this.password).then(success => {
            this.password = null;
            this.password2 = null;
        });
    }
}


// WEBPACK FOOTER //
// ./src/pages/settings/settings.ts